module.exports = __webpack_public_path__ + "images/mdj/members/message/inboxlist/inboxlist_icon03-581b6599995411956bf8e968b3c2de01.png";